<template>
  <ml-input v-if="readonly" v-model="data" style="color: red" readonly class="w-full flex-1" />
  <vs-select v-else v-model="data" autocomplete :disabled="disabled" :placeholder="placeholder">
    <fragment v-if="typeof options[0] === 'string'||typeof options[0] === 'number'">
      <vs-select-item v-for="option in options" :value="option" :text="option" :key="option" />
    </fragment>
    <fragment v-else>
      <vs-select-item v-for="(option, option_i) in options" :key="`select-item-${option_i}-${option.value}`" :value="option.value" :text="option.text || option.value" />
    </fragment>
  </vs-select>
</template>

<script>
export default {
  name: "CustomOptionSelector",
  props: {
    value: String | Number,
    options: Array,
    disabled: Boolean,
    readonly: Boolean,
    placeholder: {
      type: String,
      default: "선택",
    },
  },
  data() {
    return {
      data: this.value,
    };
  },
  watch: {
    value() {
      this.data = this.value;
    },
    data(/*value*/) {
      this.$emit("input", this.data);
    },
  },
  mounted() {
    if (!this.value) {
      this.data = "";
      this.$emit("input", this.data);
    }
  },
};
</script>

<style scoped></style>
